import ConsumerFilterOrder from "./ConsumerFilterOrder";

export function getMacroCategoryOrder(productCategory) {
    if (process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategory) {
        return [...ConsumerFilterOrder.customMacroCategoryOrderHairCare];
    }
    return [];
}

export default function GetConsumerFilterOrder(category, defaultTitle = "") {
    if (process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === category) {
        return [...ConsumerFilterOrder.customOrderOralCare];
    } else if (process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === category) {
        return [...ConsumerFilterOrder.customOrderSkinCleansing];
    } else if (process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === category) {
        return [...ConsumerFilterOrder.customOrderSkinCare];
    } else if (process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === category) {
        if (defaultTitle === "clt") {
            return [...ConsumerFilterOrder.customOrderUnileverFragranceHouseCLT];
        } else {
            return [...ConsumerFilterOrder.customOrderUnileverFragranceHouseHUT];
        }
    } else {
        return [...ConsumerFilterOrder.customOrder];
    }
}
